"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RowTwoCol = require("./RowTwoCol.styles");

var _getComponent = _interopRequireDefault(require("../../../utils/getComponent"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * RowTwoCol - One column wrapper component
 */
var RowTwoCol = function RowTwoCol(_ref) {
  var className = _ref.className,
      children = _ref.children,
      dataTestId = _ref.dataTestId,
      props = _objectWithoutProperties(_ref, ["className", "children", "dataTestId"]);

  return /*#__PURE__*/_react.default.createElement(_RowTwoCol.StyledRowTwoCol, _extends({}, props, {
    className: className,
    "data-test-id": dataTestId
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-row-two-col-left-content"
  }, (0, _getComponent.default)('leftContent', children)), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-row-two-col-right-content"
  }, (0, _getComponent.default)('rightContent', children)));
};

RowTwoCol.propTypes = {
  /** Children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** hook for overriding component styles */
  className: _propTypes.default.string,

  /** dataTestId is used optionally here in cases where it's the top-level component in other components */
  dataTestId: _propTypes.default.string
};
RowTwoCol.defaultProps = {
  children: undefined,
  className: '',
  dataTestId: ''
};
var _default = RowTwoCol;
exports.default = _default;